<!-- <p>Ja s'ha acabat la preinscripció {{preinscripcio | json}}</p>
<p>{{preinscripcio.alumne.dataNaixement | date:'fullDate'}}</p> -->
<form #formulari="ngForm">
    <div *ngIf="preinscripcio.estat==1">
        <p i18n>La preinscripció s'ha realitzat correctament i es troba pendent de revisió.</p>
        <p i18n>Comprova que reps uns correu electrònic a l'adreça que ens has indicat. </p>
        <p i18n>En cas contrari posa't en contacte amb nosaltres masters@udg.edu</p>
    </div>
    <p *ngIf="preinscripcio.estat==2" i18n>La preinscripció s'ha realitzat correctament i es troba pendent de resolució.</p>
    <p *ngIf="preinscripcio.estat==4" i18n>La preinscripció ha estat acceptada.</p>
    <p *ngIf="preinscripcio.estat==8" i18n>La preinscripció ha estat denegada.</p>
    <p *ngIf="preinscripcio.estat==16" i18n>La preinscripció ha estat anul·lada.</p>
    <p *ngIf="preinscripcio.estat==32" i18n>La preinscripció ha estat preacceptada i està pendent de pagar l'import d'acceptació. </p>
    <p *ngIf="preinscripcio.estat==128" i18n>La preinscripció es troba en tràmit.</p>
    <p *ngIf="preinscripcio.estat==256" i18n>S'ha renunciat a la preinscripció.</p>
    <div class="pre-controls-right" *ngIf="preinscripcio.potModificar">
        <button mat-raised-button matStepperPrevious i18n>Torna</button>
    </div>
</form>



// WEBPACK FOOTER //
// ./src/app/confirmacio/confirmacio.component.html